// services/formService.js
import cookieService from './cookieService';
import trackingService from './trackingService';
import { ref, push, set } from 'firebase/database';
import { db } from './firebaseConfig';

export class FormService {
  async submitForm(formData, formType = 'contact', options = {}) {
    try {
      // 1. Save to cookie
      if (formData.name || formData.email) {
        cookieService.setUserData(formData);
      }

      // 2. Track profile update if user details provided
      if (formData.name || formData.email || formData.phone) {
        await trackingService.updateProfile({
          name: formData.name,
          email: formData.email,
          phone: formData.phone
        });
      }

      // 3. Track form submission
      await trackingService.track('form_submission', {
        formType,
        formFields: Object.keys(formData)
      });

      // 4. Track additional events if specified
      if (options.trackEvent) {
        await trackingService.track(options.trackEvent, {
          formType,
          ...options.eventData
        });
      }

      // 5. Analytics
      this.trackAnalytics(formType, formData);

      // Track phone verification if applicable
      if (formData.phoneVerified) {
        await trackingService.track('form_submitted_verified_phone', {
          formType,
          phone: formData.phone
        });
      } else if (formData.phoneValidationFailed) {
        await trackingService.track('form_submitted_phone_validation_failed', {
          formType,
          phone: formData.phone
        });
      }

      // 6. Save to database
      const dbResult = await this.saveToDatabase(formData, formType);

      return {
        success: true,
        data: dbResult
      };

    } catch (error) {
      console.error('Form submission error:', error);
      throw error;
    }
  }

  // Simple tracking method for any event
  async trackEvent(event, data = {}) {
    return trackingService.track(event, data);
  }

  // Your existing methods (unchanged)
  trackAnalytics(formType, formData) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'form_submit', {
        form_type: formType,
        form_name: formType,
        event_category: 'form',
        event_label: `${formType}_submission`
      });
    }
    console.log('GA Event: form_submission', { formType, formData });
  }

  async saveToDatabase(formData, formType) {
    try {
      const submissionsRef = ref(db, `forms/${formType}`);
      const newSubmissionRef = push(submissionsRef);

      const dataToSave = {
        ...formData,
        formType,
        submittedAt: new Date().toISOString(),
        userId: trackingService.getUserId(),
        influencerId: trackingService.getInfluencerId(),
        metadata: {
          url: typeof window !== 'undefined' ? window.location.href : '',
          userAgent: typeof window !== 'undefined' ? navigator.userAgent : '',
        }
      };

      await set(newSubmissionRef, dataToSave);

      return {
        id: newSubmissionRef.key,
        status: 'success',
        message: 'Saved to Firebase successfully.',
      };
    } catch (error) {
      console.error('Firebase save failed:', error);
      throw error;
    }
  }

  getPrefilledData() {
    return cookieService.getUserData();
  }

  clearUserData() {
    cookieService.clearUserData();
  }
}

export default new FormService();